const BASE_URL = "https://www.youzhioffer.com"; // api请求地址
const API_URL = `${BASE_URL}/api/zhao`; //后台接口域名
const IMG_URL = "";
export { BASE_URL, IMG_URL, API_URL };
